import React, { useState } from "react";
import {connect} from 'react-redux';
import OutsideClickHandler from "react-outside-click-handler";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "../../../../../../../../ui/Avatar";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import DeleteConfirmationModal from "../../../../../../../../ui/DeleteConfirmationModal";
import { deleteStudent } from "../../../../store/delete"

const useStyles = makeStyles(() => ({
    root: {
        width: 240,
        height: 190,
        padding: 10,
        background: "#FFFFFF",
        border: "1px solid #CACCD1",
        boxSizing: "border-box",
        boxShadow: "3px 3px 5px rgba(0, 0, 0, 0.1)",
        position: "relative"
    },
    line: {
        height: "1px",
        background: "#CACCD1",
        position: "absolute",
        left: "0%",
        right: "0%",
        top: "27.89%",
        bottom: "72.11%"
    },
    profileInfo: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column"
    },
    avatarContainer: {
        width: 80,
        height: 80,
        border: "1px solid #CACCD1",
        boxSizing: "border-box",
        borderRadius: "75px",
        background: "#FFFFFF",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1
    },
    name: {
        marginTop: 10,
        fontSize: "14px",
        textAlign: "center",
        color: "#000000"
    },
    post: {
        marginTop: 7,
        fontSize: "10px",
        textAlign: "center",
        textTransform: "uppercase",
        color: "#596E79"
    },
    moreIcon: props => ({
        position: "absolute",
        left: "88.33%",
        right: "4.17%",
        top: "7%",
        cursor: "pointer",
        color: props.isOpened ? "#FFFFFF" : "#C4C4C4",
        zIndex: 100
    }),
    docPopover: props => ({
        display: props.isOpened ? "block" : "none",
        position: "absolute",
        left: "40%",
        right: "0%",
        top: "0%",
        bottom: "0%",
        background: "rgba(89, 110, 121, 0.8)",
        paddingTop: 45,
        zIndex: 1
    }),
    popoverItem: {
        background: "rgba(255, 255, 255, 0)",
        color: "#FFFFFF",
        height: 32,
        padding: "8px 16px",
        cursor: "pointer",
        "&:hover": {
            background: "rgba(255, 255, 255, 0.2)"
        }
    },
    iconsContainer: {
        bottom: "0",
        left: "0",
        padding: 10,
        display: "flex",
        position: "absolute",
        width: "100%",
        justifyContent: "space-between"
    },
    iconsItem: {
        display: "flex",
        flexDirection: "row"
    }
}));

export const transformNameInfoInitials = name => {
    const [lastName, firstName, middleName] = name.split(" ");

    return `${lastName} ${firstName ? firstName[0] + "." : ""}${
        middleName ? middleName[0] + "." : ""
    }`;
};

const StudentCard = ({
  data,
  masterClassId,
  update,
  reload,
  deleteStudent,
  isDeletingStudent }) => {
    const [isOpened, open] = useState(false);
    const [isDeleteStudentOpened, openDeleteStudent] = useState(false);
    const classes = useStyles({ isOpened });

    return (
        <div className={classes.root}>
            <span className={classes.line}></span>
            {isOpened
              ? <MoreVertIcon
                  className={classes.moreIcon}
                  onClick={() => open(!isOpened)}/>
              : <MoreHorizIcon
                className={classes.moreIcon}
                onClick={() => open(!isOpened)}/>
              }
            <DeleteConfirmationModal
                open={isDeleteStudentOpened}
                handleClose={() => openDeleteStudent(false)}
                onConfirm={() => deleteStudent(masterClassId, data.id)}
                modalText="Удалить студента с мастер-класса?"
            />
            <div className={classes.profileInfo}>
                {data.avatar ? (
                    <Avatar
                        imageId={data.avatar}
                        className={classes.avatarContainer}
                    />
                ) : (
                    <div className={classes.avatarContainer}>
                        <PersonOutlineOutlinedIcon
                            style={{ color: "#CACCD1" }}
                        />
                    </div>
                )}
                <div className={classes.name}>
                    {transformNameInfoInitials(data.name)}
                </div>
                <div className={classes.post}>{data.postName}</div>
                <div className={classes.iconsContainer}>
                    <div className={classes.iconsItem}>

                    </div>
                    <div className={classes.iconsItem}></div>
                </div>
            </div>
            <OutsideClickHandler onOutsideClick={() => open(false)}>
                <div className={classes.docPopover}>
                    <div
                        className={classes.popoverItem}
                        onClick={() => {
                            open(false);
                            openDeleteStudent(true);
                        }}
                    >
                        Удалить
                    </div>
                </div>
            </OutsideClickHandler>
        </div>
    );
};

const mapStateToProps = state => ({
  isDeletingStudent: state.masterClasses.isDeletingStudent
});

const mapDispatchToProps = dispatch => ({
  deleteStudent: (id, studentId) => dispatch(deleteStudent(id, studentId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudentCard);
